import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Al cambiar de página el móvil se quedaba mirando el footer: siempre volvemos arriba.
export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, left: 0, behavior: "instant" }); }, [pathname]);
  return null;
};
